// extracted by mini-css-extract-plugin
module.exports = {"arrow-left":"ChatActionButton_arrow-left_1oCcl","arrow-right":"ChatActionButton_arrow-right_BhvzL","component":"ChatActionButton_component_q_821"};